// Reviews, word by word, on the Why bamboo page (sections/sivana-bamboo-story.liquid, .sbs-reviews;
// styles in assets/sivana-bamboo-story.css, "6. Reviews").
// The stage holds under the header while the scroll plays the quotes in turn. Each quote assembles itself
// from soft, scattered words (they drift in from slightly different places, out of a blur), then the
// reviewer and the piece they bought appear underneath; the words lift away as the next quote forms. The
// five stars light up one at a time as the section arrives, and the big serif quote mark drifts slowly.
// Runs from the scroll position (works with any scroller), so it plays the same on every browser.
// With reduced motion the script does nothing and the quotes simply stack.
const root = document.querySelector('[data-sbs-review-words]');
const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;

if (root && !reduceMotion) {
  const clamp = (value, min = 0, max = 1) => Math.min(max, Math.max(min, value));
  const easeOut = (t) => 1 - Math.pow(1 - t, 3);
  const easeInOut = (t) => (t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2);

  // Same "random" scatter on every visit
  let seed = 7;
  const random = () => (seed = (seed * 9301 + 49297) % 233280) / 233280;

  root.classList.add('is-live');
  const stage = root.querySelector('.sbs-reviews__stage');
  const mark = root.querySelector('.sbs-reviews__mark');
  const stars = [...root.querySelectorAll('[data-star]')];
  const count = root.querySelector('[data-count]');
  const countFill = root.querySelector('[data-count-fill]');
  const quotes = [...root.querySelectorAll('.sbs-review')].map((review) => ({
    words: [...review.querySelectorAll('.sbs-review__word')].map((word) => ({
      el: word,
      dx: (random() - 0.5) * 90,
      dy: 30 + random() * 50,
      turn: (random() - 0.5) * 10,
    })),
    by: review.querySelector('.sbs-review__by'),
  }));
  const total = quotes.length;
  const START = 0.03;
  const SPAN = 0.94 / total;

  const render = () => {
    const box = root.getBoundingClientRect();
    const view = window.innerHeight;
    const stuckAt = parseFloat(getComputedStyle(stage).top) || 0;
    const travel = root.offsetHeight - stage.offsetHeight;
    const p = clamp((stuckAt - box.top) / travel);
    const arriving = clamp((view - box.top) / view);

    stars.forEach((star, i) => (star.style.opacity = 0.15 + 0.85 * clamp((arriving - 0.45 - i * 0.07) / 0.12)));
    mark.style.transform = `translateY(${(0.5 - p) * 18}vh)`;

    let active = 0;
    quotes.forEach((quote, k) => {
      const t = (p - START - k * SPAN) / SPAN;
      if (t >= 0) active = k; // the latest quote to start, so the count stays on the last one at the end
      const last = k === total - 1;
      const n = quote.words.length;
      quote.words.forEach((word, j) => {
        const inn = easeOut(clamp((t - (j / n) * 0.28) / 0.2));
        const out = last ? 0 : easeInOut(clamp((t - 0.78 - (j / n) * 0.1) / 0.12));
        word.el.style.opacity = inn * (1 - out);
        word.el.style.transform = `translate(${(1 - inn) * word.dx}px, ${(1 - inn) * word.dy - out * 46}px) rotate(${(1 - inn) * word.turn}deg)`;
        word.el.style.filter = inn >= 1 && out === 0 ? 'none' : `blur(${(1 - inn) * 12 + out * 8}px)`;
      });
      const shown = easeOut(clamp((t - 0.42) / 0.14)) * (1 - (last ? 0 : clamp((t - 0.8) / 0.1)));
      quote.by.style.opacity = shown;
      quote.by.style.transform = `translateY(${(1 - shown) * 20}px)`;
      quote.by.style.pointerEvents = shown > 0.5 ? 'auto' : 'none';
    });
    count.textContent = String(active + 1).padStart(2, '0');
    countFill.style.transform = `scaleX(${clamp((p - START) / 0.94)})`;
  };

  // Only work while the section is on or near the screen
  let near = false;
  let queued = false;
  const schedule = () => {
    if (!near || queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      render();
    });
  };
  new IntersectionObserver(
    ([entry]) => {
      near = entry.isIntersecting;
      if (near) render();
    },
    { rootMargin: '100% 0px' }
  ).observe(root);
  document.addEventListener('scroll', schedule, { capture: true, passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  render();
}
